<template>
    <flex-element
        v-plaintext
        :element-type="elementType"
        class="f-break-words"
        :tag="renderTag"
    >
        <span v-if="isDate">
            {{ formattedValue }}
        </span>
        <span
            v-else
            v-text-select="singleLineTextNew"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ATextSingleLine } from '@/data/data-models';
import { formatDate } from '@/utils/date';

const PLACEHOLDER_TEXT = '[Text here]';
const CUSTOM_ATTR_NAME = 'date-format';

export default {
    name: 'a-text-single-line',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Single Line Text',
        },

        singleLineText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },

        tagDefault: {
            type: String,
            default: 'div',
        },

        templateId: {
            type: String,
            default: '{A92BDC20-5F74-42AE-B32C-B952BC9D5F63}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            singleLineTextNew: '',
            tagNew: '',
            isDate: false,
        };
    },

    computed: {
        renderTextPreview() {
            if (this.singleLineTextNew === PLACEHOLDER_TEXT) {
                return '';
            }
            return this.singleLineTextNew;
        },

        renderTag() {
            return this.tagNew || this.tagDefault;
        },

        updatedElement() {
            return new ATextSingleLine({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew === PLACEHOLDER_TEXT ? '' : this.singleLineTextNew,
                tag: this.renderTag,
            });
        },

        formattedValue() {
            const dateFormat = this.getElementData(CUSTOM_ATTR_NAME);
            if (dateFormat && this.singleLineText) {
                return formatDate(this.singleLineText, dateFormat);
            }
            return this.renderTextPreview;
        },
    },

    mounted() {
        const dateFormat = this.getElementData(CUSTOM_ATTR_NAME);
        if (dateFormat && this.singleLineText) {
            this.isDate = true;
        }
    },

    methods: {
        setFieldValues() {
            this.singleLineTextNew = this.singleLineText
                || (this.$slots.default ? this.$slots.default[0].text.trim() : PLACEHOLDER_TEXT);
            this.tagNew = this.tag;
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },
    },
};
</script>
